module.exports = __webpack_public_path__ + "static/media/adidas_puma_box.2150e56b.png";